export { Categories } from '~/web-frontend-components/line/outcomes/additional/Сategories';
export { Tables } from '~/web-frontend-components/line/outcomes/additional/Tables';
export { Description } from '~/web-frontend-components/line/outcomes/Description';
export { default as HeadTable } from '~/web-frontend-components/line/outcomes/HeadTable';



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/Outcomes.js